import {decorate, observable, action} from 'mobx';
import _ from 'lodash';

class SparePartsFinderTextSearchBasketStore {
    searchParameterConfigurationIds = {};
    basketIsOpen = false;

    addToBasketIfNotExistsSingle(searchParameter, id) {
        var current = this._getCurrentConfigurationIds(searchParameter);
        this.searchParameterConfigurationIds = Object.assign({}, {
            ...this.searchParameterConfigurationIds,
            [searchParameter]: _.xor(current, [id])
        })
    }

    addToBasketIfNotExistsMany(searchParameter, ids) {
        var current = this._getCurrentConfigurationIds(searchParameter);
        this.searchParameterConfigurationIds = Object.assign({}, {
            ...this.searchParameterConfigurationIds,
            [searchParameter]: _.union(current, ids)
        })
    }

    removeFromBasketMany(ids) {
        let temp = {};
        for (let [name, value] of Object.entries(this.searchParameterConfigurationIds)) {
            temp[name] = value.filter(x => !ids.includes(x));
        }

        this.searchParameterConfigurationIds = temp;
    }

    isInBasket(searchParameter, id) {
        return this._getCurrentConfigurationIds(searchParameter).includes(id);
    }

    hasAny() {
        return Object.values(this.searchParameterConfigurationIds).some(x => x && x.some(c => c));
    }

    setBasketIsOpen(value) {
        this.basketIsOpen = value;
    }

    clearBasket() {
        this.searchParameterConfigurationIds = {};
    }

    _getCurrentConfigurationIds(searchParameter) {
        return this.searchParameterConfigurationIds[searchParameter] || [];
    }
}

decorate(SparePartsFinderTextSearchBasketStore, {
    searchParameterConfigurationIds: observable,
    basketIsOpen: observable,
    addToCartIfNotExistsSingle: action,
    addToCartIfNotExistsMany: action,
    removeFromBasketMany: action,
    setBasketIsOpen: action
})

const store = new SparePartsFinderTextSearchBasketStore();
export default store;